import {
  AssigneePickerFragment,
  Document,
  Frequency,
  Tag,
  VirtualEventStatus,
} from "generated-graphql/graphql";

export type TaskFormType = {
  title: string;
  description: string;
  assignee: AssigneePickerFragment | null;
  deadline: Date | null;
  status: VirtualEventStatus | null;
  frequency: Frequency;
  interval: number;
  reminderDays: { id: string; days: number }[];
  subtasks: { title: string; completed: boolean; id: string }[];
  facilityIds: string[];
  documents: Pick<
    Document,
    "id" | "title" | "fileExtension" | "documentType" | "sizeMegabytes"
  >[];
  tags: Pick<Tag, "id" | "name">[];
  links: { url: string; id: string }[];
  watchers: AssigneePickerFragment[];
  isCompleted: boolean;
  completedOn: Date | null;
  isSuggested: boolean;
};

export const TASK_FREQUENCY_ORDER = [
  Frequency.Once,
  Frequency.Weekly,
  Frequency.Monthly,
  Frequency.Quarterly,
  Frequency.Yearly,
];
